import styled from 'styled-components';

import { Button } from '@cognite/cogs-core-v11/components/button/button.tsx';
import { Flex } from '@cognite/cogs-core-v11/components/flex/flex.tsx';

export const Container = styled(Flex).attrs({
  gap: 16,
  wrap: 'wrap',
  alignContent: 'flex-start',
})`
  width: 100%;
  padding: 16px 16px;
  overflow: auto;
  background: ${({ theme }) => theme['surface--muted']};
`;

export const Wrapper = styled.div`
  padding: 16px;
`;

export const SaveButton = styled(Button)`
  width: 200px;
`;

export const AddButton = styled(Button)`
  width: 200px;
`;
